import { Title } from "./PostsPromoListFacade.styles";
import React from "react";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";
import { Stack } from "@mui/material";
import { usePromoPosts } from "./usePromoPosts";
import { PostsPromoListFeedEntryComponent } from "./PostsPromoListFeedEntryComponent";
import { PostsPromoSliderFacade } from "../PostsPromoSlider/PostsPromoSliderFacade";

export function PostsPromoEntryComponent() {
    const { getConfigs } = useGlobalConfigs();

    const { posts } = usePromoPosts();

    const promoSectionEnabled = posts.length > 0;
    const promoSliderEnabled =
        getConfigs()?.tippspielPromotionSegmentSliderEnabled;

    const promoEnabled = promoSectionEnabled || promoSliderEnabled;

    if (!promoEnabled) {
        return null;
    }

    return (
        <Stack
            width="100%"
            style={{
                backgroundColor: "var(--community-header-background-color)",
            }}
        >
            <Title padding="0 16px" className={"fontFamily-inherited"}>
                {getConfigs()?.tippspielPromotionSegmentHeadline}
            </Title>
            {promoSectionEnabled && (
                <PostsPromoListFeedEntryComponent posts={posts} />
            )}
            {promoSliderEnabled && <PostsPromoSliderFacade />}
        </Stack>
    );
}
